var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGoogleStroke = function SvgGoogleStroke(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.4419 20.0455H24.5581V29.5114H37.7302C36.5023 35.525 31.3674 38.9773 24.5581 38.9773C16.5209 38.9773 10.0465 32.5182 10.0465 24.5C10.0465 16.4818 16.5209 10.0227 24.5581 10.0227C28.0186 10.0227 31.1442 11.2477 33.6 13.2523L40.7442 6.125C36.3907 2.33864 30.8093 0 24.5581 0C10.9395 0 0 10.9136 0 24.5C0 38.0864 10.9395 49 24.5581 49C36.8372 49 48 40.0909 48 24.5C48 23.0523 47.7767 21.4932 47.4419 20.0455Z",
    fill: "#0258FF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogleStroke, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google-stroke.29c436b2.svg";
export { ForwardRef as ReactComponent };